"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Info = _interopRequireDefault(require("../model/Info"));
var _ScriptRunResult = _interopRequireDefault(require("../model/ScriptRunResult"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* Default service.
* @module api/DefaultApi
* @version 1.0.0
*/
var DefaultApi = /*#__PURE__*/function () {
  /**
  * Constructs a new DefaultApi. 
  * @alias module:api/DefaultApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DefaultApi(apiClient) {
    _classCallCheck(this, DefaultApi);
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the getPipelineInfo operation.
   * @callback module:api/DefaultApi~getPipelineInfoCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Info} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get metadata about this pipeline
   * @param {String} descriptionPath Where to find the pipeline in ./pipeline folder.
   * @param {module:api/DefaultApi~getPipelineInfoCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Info}
   */
  _createClass(DefaultApi, [{
    key: "getPipelineInfo",
    value: function getPipelineInfo(descriptionPath, callback) {
      var postBody = null;
      // verify the required parameter 'descriptionPath' is set
      if (descriptionPath === undefined || descriptionPath === null) {
        throw new Error("Missing the required parameter 'descriptionPath' when calling getPipelineInfo");
      }
      var pathParams = {
        'descriptionPath': descriptionPath
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Info.default;
      return this.apiClient.callApi('/pipeline/{descriptionPath}/info', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getPipelineOutputs operation.
     * @callback module:api/DefaultApi~getPipelineOutputsCallback
     * @param {String} error Error message, if any.
     * @param {Object.<String, {String: String}>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the output folders of the scripts composing this pipeline
     * @param {String} id Where to find the pipeline in ./script folder.
     * @param {module:api/DefaultApi~getPipelineOutputsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object.<String, {String: String}>}
     */
  }, {
    key: "getPipelineOutputs",
    value: function getPipelineOutputs(id, callback) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPipelineOutputs");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = {
        'String': 'String'
      };
      return this.apiClient.callApi('/pipeline/{id}/outputs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getScriptInfo operation.
     * @callback module:api/DefaultApi~getScriptInfoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Info} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get metadata about this script
     * @param {String} scriptPath Where to find the script in ./script folder.
     * @param {module:api/DefaultApi~getScriptInfoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Info}
     */
  }, {
    key: "getScriptInfo",
    value: function getScriptInfo(scriptPath, callback) {
      var postBody = null;
      // verify the required parameter 'scriptPath' is set
      if (scriptPath === undefined || scriptPath === null) {
        throw new Error("Missing the required parameter 'scriptPath' when calling getScriptInfo");
      }
      var pathParams = {
        'scriptPath': scriptPath
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Info.default;
      return this.apiClient.callApi('/script/{scriptPath}/info', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the pipelineListGet operation.
     * @callback module:api/DefaultApi~pipelineListGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<String>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a list of available pipelines
     * @param {module:api/DefaultApi~pipelineListGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<String>}
     */
  }, {
    key: "pipelineListGet",
    value: function pipelineListGet(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];
      return this.apiClient.callApi('/pipeline/list', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the runPipeline operation.
     * @callback module:api/DefaultApi~runPipelineCallback
     * @param {String} error Error message, if any.
     * @param {String} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Run this pipeline
     * @param {String} descriptionPath Where to find the script in ./script folder.
     * @param {Object} opts Optional parameters
     * @param {String} opts.body Content of input.json for this run
     * @param {module:api/DefaultApi~runPipelineCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link String}
     */
  }, {
    key: "runPipeline",
    value: function runPipeline(descriptionPath, opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];
      // verify the required parameter 'descriptionPath' is set
      if (descriptionPath === undefined || descriptionPath === null) {
        throw new Error("Missing the required parameter 'descriptionPath' when calling runPipeline");
      }
      var pathParams = {
        'descriptionPath': descriptionPath
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/pipeline/{descriptionPath}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the runScript operation.
     * @callback module:api/DefaultApi~runScriptCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScriptRunResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Run this script
     * Run the script specified in the URL. Must include the extension.
     * @param {String} scriptPath Where to find the script in ./script folder
     * @param {Object} opts Optional parameters
     * @param {String} opts.body Content of input.json for this run
     * @param {module:api/DefaultApi~runScriptCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScriptRunResult}
     */
  }, {
    key: "runScript",
    value: function runScript(scriptPath, opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];
      // verify the required parameter 'scriptPath' is set
      if (scriptPath === undefined || scriptPath === null) {
        throw new Error("Missing the required parameter 'scriptPath' when calling runScript");
      }
      var pathParams = {
        'scriptPath': scriptPath
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = _ScriptRunResult.default;
      return this.apiClient.callApi('/script/{scriptPath}/run', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the scriptListGet operation.
     * @callback module:api/DefaultApi~scriptListGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<String>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a list of available scripts
     * @param {module:api/DefaultApi~scriptListGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<String>}
     */
  }, {
    key: "scriptListGet",
    value: function scriptListGet(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];
      return this.apiClient.callApi('/script/list', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the stopPipeline operation.
     * @callback module:api/DefaultApi~stopPipelineCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Stop the specified pipeline run
     * @param {String} id Where to find the pipeline in ./script folder.
     * @param {module:api/DefaultApi~stopPipelineCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "stopPipeline",
    value: function stopPipeline(id, callback) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling stopPipeline");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/pipeline/{id}/stop', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
  return DefaultApi;
}();
exports.default = DefaultApi;